import { Stack, styled } from "@mui/material";

export const URadioBoxWrapper = styled(Stack)({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '8px',
    padding: '16px',
    gap: '16px',
    boxSizing: 'border-box',
    '.MuiRadio-root': {
        paddingTop: '0px',
        paddingBottom: '0px',
        paddingRight: '14px'
    }
})
